// Usage:
// import Superstore from 'superstore';
// export default new Superstore.Stores.Local({
//     name: 'my-local-store'
// });

import Base         from './base';
import localForage  from 'localforage';

var buffer = {};

class Local extends Base {
    constructor(options) {
        super(options);

        var _ = this;

        _.db = localForage.createInstance({
            name: options.name
        });
    }

    query(model) {
        var _ = this;
        return _.db.getItem(model._key);
    }

// find
// save
// delete

    save(item) {
        super.save(item);

        var _ = this,
            modelKey = item._model._key;

        clearTimeout(buffer[modelKey]);

        buffer[modelKey] = setTimeout(function saveLocal() {
            _.db.setItem(modelKey, item._model.data.map(function(item) {
                return item.toJSON();
            }), function() {
                _.logger.log('saved', modelKey);
            });
        }, 100);
    }

    destroy(item) {
        var _ = this;
        item._model.data.splice(item._model.data.indexOf(item), 1);
        _.save(item);
    }
}

export default Local;
